module.exports = __webpack_public_path__ + "img/age-confirm-mobile-second-img.7ad82ef1.png";